import useDomain from '@/hooks/useDomain';

/** `/tracker-ai/<section>/<domain_slug>/<domain>` plus optional query. */
export function trackerAiPath(
  section: string,
  domainSlug?: string | null,
  domain?: string | null,
  search?: string,
): string {
  const suffix = domainSlug && domain ? `/${domainSlug}/${domain}` : '';
  const path = `/tracker-ai/${section}${suffix}`;
  if (!search) return path;
  const query = search.startsWith('?') ? search : `?${search}`;
  return `${path}${query}`;
}

export function useTrackerAiPath() {
  const { domain_slug, domain } = useDomain() as {
    domain_slug?: string | null;
    domain?: string | null;
  };
  return (section: string, search?: string) =>
    trackerAiPath(section, domain_slug, domain, search);
}
